






























































































import { Component, Mixins, Prop, Emit, Ref } from "vue-property-decorator";
import { PatientItem, DefaultPatientItem } from "@/components/ai/types";
import {
  AiReportExperimentCondition,
  DefaultAiReportExperimentCondition,
} from "#/model/admin/index";
import { SELECT_FILTER } from "#/const";
import {
  ColumnKey,
  HeaderColumn,
  IsFilterMatch,
} from "#/components/selectFilter/filter";
import ExperimentPatientInfoViewer from "@/components/ai/ExperimentPatientInfoViewer.vue";
import SelectFilter from "#/components/selectFilter/SelectFilter.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";

@Component({
  components: {
    ExperimentPatientInfoViewer,
    SelectFilter,
  },
})
/** お試し条件選択 */
export default class ExperimentConditionSelector extends Mixins(
  AxiosMixin,
  UtilMixin
) {
  /** Ref */

  /** フィルター制御 */
  @Ref("selectFilter") private readonly selectFilter!: SelectFilter;

  /** Prop */

  /** 利用画面 1:計画書 2:報告書 */
  @Prop({ default: 1 }) private viewType!: number;

  /** お試し条件 */
  @Prop({
    default: () => [],
  })
  private experimentConditions!: AiReportExperimentCondition[];

  /** 変数 */

  /** ダイアログ制御 */
  private dialog = false;

  /** フィルター用キーワード */
  private searchKeyword = "";

  /** 1ページあたりの表示件数 */
  private itemPerPage = 25;

  /** 表の現在のページ数 */
  private pageNo = 1;

  /** 選択(詳細)利用者データ */
  private patientItem: PatientItem = DefaultPatientItem();

  /** 選択(詳細)お試し条件 */
  private experimentCondition = DefaultAiReportExperimentCondition();

  /** お試し条件データテーブル用ヘッダー */
  private get Headers(): HeaderColumn[] {
    const headers: HeaderColumn[] = [
      {
        text: "",
        value: "actions",
        width: "250px",
        sortable: false,
      },
      {
        text: "企業コード",
        value: "co_code",
        width: "130px",
        sortable: true,
        filter: (val: object) => this.columnFilter("co_code", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT_PARTIAL,
          key: "co_code",
          text: "企業コード",
          selectable: [],
        },
      },
      {
        text: "法人名",
        value: "co_name",
        width: "200px",
        sortable: true,
        filter: (val: object) => this.columnFilter("co_name", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT_PARTIAL,
          key: "co_name",
          text: "法人名",
          selectable: [],
        },
      },
      {
        text: "事業所コード",
        value: "kst_no",
        width: "150px",
        sortable: true,
        filter: (val: object) => this.columnFilter("kst_no", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT_PARTIAL,
          key: "kst_no",
          text: "事業所コード",
          selectable: [],
        },
      },
      {
        text: "事業所名",
        value: "office_name",
        width: "240px",
        sortable: true,
        filter: (val: object) => this.columnFilter("office_name", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT_PARTIAL,
          key: "office_name",
          text: "事業所名",
          selectable: [],
        },
      },
      {
        text: "利用者氏名",
        value: "patient_name",
        width: "150px",
        sortable: true,
        filter: (val: object) => this.columnFilter("patient_name", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT_PARTIAL,
          key: "patient_name",
          text: "利用者氏名",
          selectable: [],
        },
      },
    ];

    if (this.viewType == 2) {
      headers.push(
        ...[
          {
            text: "報告月",
            value: "option.yearmonth",
            width: "150px",
            sortable: true,
            filter: (val: object) => this.columnFilter("option.yearmonth", val),
            columnKey: {
              type: SELECT_FILTER.FILTER_TYPE.MONTH,
              key: "option.yearmonth",
              text: "報告月",
              selectable: [],
            },
          },
          {
            text: "本日の状態（バイタル）",
            value: "option.use_vital",
            width: "200px",
            sortable: true,
            filter: (val: object) => this.columnFilter("option.use_vital", val),
            columnKey: {
              type: SELECT_FILTER.FILTER_TYPE.LIST,
              key: "option.use_vital",
              text: "本日の状態（バイタル）",
              selectable: ["含む", "含まない"],
            },
          },
          {
            text: "観察項目",
            value: "option.use_observation",
            width: "120px",
            sortable: true,
            filter: (val: object) =>
              this.columnFilter("option.use_observation", val),
            columnKey: {
              type: SELECT_FILTER.FILTER_TYPE.LIST,
              key: "option.use_observation",
              text: "観察項目",
              selectable: ["含む", "含まない"],
            },
          },
          {
            text: "看護記録書Ⅰ(家族情報)",
            value: "option.use_vn_record_fam",
            width: "140px",
            sortable: true,
            filter: (val: object) =>
              this.columnFilter("option.use_vn_record_fam", val),
            columnKey: {
              type: SELECT_FILTER.FILTER_TYPE.LIST,
              key: "option.use_vn_record_fam",
              text: "看護記録書Ⅰ(家族情報)",
              selectable: ["含む", "含まない"],
            },
          },
        ]
      );
    }

    headers.push({
      text: "コメント",
      value: "comment",
      width: "200px",
      sortable: true,
      filter: (val: object) => this.columnFilter("comment", val),
      columnKey: {
        type: SELECT_FILTER.FILTER_TYPE.EDIT,
        key: "comment",
        text: "コメント",
        selectable: [],
      },
    });

    return headers;
  }

  /** 関数 */

  /** 利用者詳細情報を取得 */
  private async fetchPatientInfo(item: AiReportExperimentCondition) {
    this.postJsonCheck(
      window.base_url +
        (this.viewType == 1
          ? "/api/admin/aivnplan/patient/detail/get"
          : "/api/admin/aimonthreport/patient/detail/get"),
      {
        view_type: this.viewType,
        agreement_id: item.agreement_id,
        patient_id: item.patient_id,
        yearmonth: item.option.yearmonth,
      },
      (res) => {
        this.patientItem = res.data.patient_item;
        this.experimentCondition = { ...item };
      }
    );
  }

  /** お試し条件削除前 */
  private async beforeDeleteExperimentCondition(
    item: AiReportExperimentCondition
  ) {
    if (!(await this.$openConfirm("お試し条件を削除しますか？"))) {
      return;
    }
    this.deleteCondition(item);
  }

  /** 表のページ変更 */
  private changePage(pageNo: number) {
    this.pageNo = pageNo;
  }

  /** 詳細表示中の行を目立たせる */
  private opendItemRowBackground(item: AiReportExperimentCondition) {
    return item.id == this.experimentCondition.id
      ? "ibow-admin-selected-item-row"
      : "";
  }

  /** 詳細表示を閉じる */
  private showDown() {
    this.patientItem = { ...DefaultPatientItem() };
  }

  /** SelectFilterの選択肢 */
  private get columnKeys(): ColumnKey[] {
    const keys = this.Headers.filter(
      (headerColumn: HeaderColumn) => headerColumn.filter != null
    ).map((headerColumn: HeaderColumn) => headerColumn.columnKey);

    if (keys.length == 0) {
      return [] as ColumnKey[];
    }

    return keys as ColumnKey[];
  }

  /** カラムフィルター */
  private columnFilter(key: string, val: unknown) {
    if (key == "option.use_vital") {
      val = val == 0 ? "含まない" : "含む";
    }
    if (key == "option.use_observation") {
      val = val == 0 ? "含まない" : "含む";
    }
    if (key == "option.use_vn_record_fam") {
      val = val == 0 ? "含まない" : "含む";
    }

    return IsFilterMatch(
      this.selectFilter.filterClauses,
      key,
      val as string | number
    );
  }

  /** ダイアログ開く */
  public open() {
    this.dialog = true;
  }

  /** ダイアログ閉じる */
  public close() {
    this.dialog = false;
  }

  /** Emit */

  /** 利用者選択 */
  @Emit("change:condition")
  private changeCondition(item: AiReportExperimentCondition) {
    return item;
  }

  /** お試し条件削除 */
  @Emit("delete:condition")
  private deleteCondition(item: AiReportExperimentCondition) {
    return item;
  }
}
